import { render } from "./OrdersTable.vue?vue&type=template&id=7f5c2f4e&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=7f5c2f4e&lang=scss"
import "./OrdersTable.vue?vue&type=style&index=1&id=7f5c2f4e&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5c2f4e"]])

export default __exports__